<template>
  <div v-if="loaded">
    <d-form @keyup.enter="saveInstructions">
      <d-card-header class="border-bottom flex-header">
        <h6
          v-if="instructions.id"
          class="m-0">
          Edycja uruchomiena dyspozycji {{ instructions.created_at }}
        </h6>
        <h6
          v-else
          class="m-0">
          Nowe uruchomienie dyspozycji
        </h6>
        <d-button @click.prevent="closeInstructions(false)">
          <i class="material-icons">close</i> Zamknij
        </d-button>
        <d-button
          @click.prevent="saveInstructions"
          theme="success">
          <i class="material-icons">save</i> Zapisz
        </d-button>
      </d-card-header>

      <d-list-group flush>
        <d-list-group-item class="p-3">
            <!-- <d-form> -->
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Wybierz typ przelewu</label>
              <v-select
                class="default-input"
                :options="transfer_types"
                :reduce="transfer_type => transfer_type.value"
                :class="{'is-invalid' : lar_errors.has('provision_transfer')}"
                v-model="instructions.provision_transfer"
                placeholder="Wybierz typ"
                label="name">
              </v-select>
              <div
                class="invalid-feedback"
                v-text="lar_errors.get('provision_transfer')">
              </div>
            </d-col>
            <d-col
              v-if="instructions.provision_transfer === 'provision'"
              md="6"
              class="form-group">
              <label>Wybierz spółkę</label>
              <v-select
                class="default-input"
                :options="allCompanies"
                v-model="company_id"
                :reduce="company => company.id"
                placeholder="Wybierz spółkę"
                label="name">
              </v-select>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Kwota</label>
              <ss-price-input
                label="Kwota"
                name="amount"
                v-model="instructions.amount"
                @input="lar_errors.clear('amount')"
                :class="{'is-invalid' : lar_errors.has('amount')}"
                placeholder="Kwota" />
              <div
                class="invalid-feedback"
                v-text="lar_errors.get('amount')">
              </div>
            </d-col>
            <d-col
              md="6"
              class="form-group">
              <ss-input
                v-model="instructions.account_number"
                name="account_number"
                label="Numer konta"
                placeholder="Numer konta">
              </ss-input>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <ss-input
                v-model="instructions.recipient"
                name="recipient"
                label="Odbiorca"
                placeholder="Imię i nazwisko">
              </ss-input>
            </d-col>
            <d-col md="6" class="form-group">
              <ss-input
                v-model="instructions.transfer_title"
                name="transfer_title"
                label="Tytuł przelewu"
                placeholder="Tytuł przelewu">
              </ss-input>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="6" class="form-group">
              <label>Data przelewu</label>
              <ss-date
                type="text"
                name="transfer_date"
                v-model="instructions.transfer_date"
                @click="lar_errors.clear('transfer_date')"
                :class="{'is-invalid' : lar_errors.has('transfer_date')}"
                placeholder=""/>
              <div
                class="invalid-feedback"
                v-text="lar_errors.get('transfer_date')">
              </div>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Przelew wykonano dnia</label>
              <ss-date
                type="text"
                name="transfer_execution_date"
                v-model="instructions.transfer_execution_date"
                @click="lar_errors.clear('transfer_execution_date')"
                :class="{'is-invalid' : lar_errors.has('transfer_execution_date')}"
                placeholder=""/>
              <div
                class="invalid-feedback"
                v-text="lar_errors.get('transfer_execution_date')">
              </div>
            </d-col>
          </d-form-row>
          <d-form-row v-if="instructions.provision_transfer === 'roll'">
            <d-col md="6" class="form-group">
              <label>Wybierz umowę</label>
              <v-select
                class="default-input"
                :options="schedules"
                v-model="unclosed_schedule"
                :reduce="schedule => schedule.debt_amount"
                placeholder="Wybierz niedomkniętą umowę"
                label="contract_number">
                <span slot="no-options">
                    Brak niedomkniętych umów.
                </span>
              </v-select>
            </d-col>
          </d-form-row>
          <d-form-row>
            <d-col md="12" class="form-group">
              <div class="flex-header mt-1 mb-3">
                <h5>
                  Warunki uruchomienia<br /><small>(edycja warunków wymaga zapisu dyspozycji)</small>
                </h5>
                <d-button
                  theme="success"
                  @click.prevent="addCondition()">
                  <i class="material-icons mr-1">add</i> Dodaj
                </d-button>
              </div>

              <table class="table mb-0 responsive-table">
                <thead class="bg-light">
                  <tr>
                    <th scope="col" class="border-0">Warunek</th>
                    <th scope="col" class="border-0">Data dodania</th>
                    <th scope="col" class="border-0">Status</th>
                    <th scope="col" class="border-0 action-cell text-center">Akcje</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(condition, index) in instructions.conditions"
                    :key="instructions.id">
                    <td>
                      <dt>Warunek</dt>
                      <dd>{{ condition.name }}</dd>
                    </td>
                    <td>
                      <dt>Data dodania</dt>
                      <dd>{{ condition.created_at }}</dd>
                    </td>
                    <td>
                      <dt>Status</dt>
                      <dd>
                        <d-checkbox
                          toggle
                          v-model="condition.status">
                          Zrealizowany
                        </d-checkbox>
                        <span
                          v-if="condition.fulfilment_date">
                          Załatwione {{ condition.fulfilment_date }} przez {{ condition.fulfilment_username }}
                        </span>
                      </dd>
                    </td>
                    <td class="text-center">
                      <dt>Akcje</dt>
                      <dd class="wsnw">
                        <d-button
                          theme="danger"
                          @click.prevent="removeCondition(index)">
                          <i class="material-icons">delete</i> Usuń
                        </d-button>
                      </dd>
                    </td>
                  </tr>
                </tbody>
              </table>
            </d-col>
          </d-form-row>
            <!-- </d-form> -->
        </d-list-group-item>
      </d-list-group>
    </d-form>

    <ss-modal
      v-if="condition_modal"
      title="Title"
      intro="bounceIn"
      outro ="bounceOut">
      <!-- HEADER -->
      <div slot="modal-header">
        Dodaj nowy warunek uruchomienia
      </div>
      <!-- BODY -->
      <div slot="modal-body">
        <d-form>
          <d-form-row>
            <d-col md="12" class="form-group">
              <ss-input
                v-model="condition.name"
                name="condition_name"
                placeholder="Treść warunku">
              </ss-input>
            </d-col>
          </d-form-row>
        </d-form>
      </div>
      <!-- FOOTER -->
      <div slot="modal-footer">
        <d-button
          @click.prevent="closeCondition()"
          theme="danger"
          class="mr-2">Zamknij
        </d-button>
        <d-button
          @click.prevent="saveCondition()"
          theme="success">
          Zapisz
        </d-button>
      </div>
    </ss-modal>
  </div>
</template>

<script>
import FormUtils from '@/utils/FormUtils.js';
import LarErrors from '@/helpers/Errors';
import SsPriceInput from '@/components/common/SsPriceInput';
import SsDate from '@/components/common/SsDate';
import instructionUtils from '@/utils/instructions';
import SsModal from '@/components/common/SsModal';
import ClientUtils from "@/utils/client";

export default {
  name: 'InstructionsForm',
  components: {
    LarErrors,
    SsPriceInput,
    SsDate,
    SsModal
  },
  props: {
    allCompanies: {
      defualt: () => [],
      type: Array
    },
    scheduleCompanyId: {
      defualt: 0,
      type: Number
    },
    scheduleContractNumber: {
      required: true,
      type: String
    },
    selectedInstructions: {
      defualt: null,
      type: Object
    }
  },
  watch: {
    'company_id' (to)  {
      this.getCompany(to, this.loaded);
    },
    'unclosed_schedule' (to) {
      if (to) {
        this.instructions.amount = this.instructions.transfer_date ? to : 0.00
      }
    },
    'instructions.provision_transfer' (to) {
      let shouldReload = this.loaded;
      if (to === 'roll') {
        this.getDebtContractsList()
      }
      if (to === 'provision') {
        this.$nextTick(function () {
          this.company_id = this.scheduleCompanyId;
          this.getCompany(this.scheduleCompanyId, shouldReload);
        })
      }
    },
    'instructions.transfer_date' (to) {
      if (to && this.instructions.provision_transfer === 'roll') {
        this.unclosed_schedule = '';
        this.getDebtContractsList();
      }
    }
  },
  data () {
    return {
      company: '',
      company_id: '',
      condition: null,
      condition_modal: false,
      instructions: {},
      lar_errors: LarErrors,
      loaded: false,
      schedules: [],
      transfer_types: _.clone(instructionUtils.transfer_types_list),
      unclosed_schedule: ''
    }
  },
  mounted () {
    this.$set(this, 'instructions', JSON.parse(JSON.stringify(this.selectedInstructions)));
    if (!this.instructions.transfer_title) {
      this.instructions.transfer_title = 'Umowa ' + this.scheduleContractNumber;
    }

    for (let i  = 0; i < this.instructions.conditions.length; i++) {
      this.instructions.conditions[i].status = !!this.instructions.conditions[i].status;
    }

    if (this.instructions.provision_transfer === 'provision') {
      this.company_id = this.scheduleCompanyId;
    }

    this.$nextTick(() => {
      this.loaded = true;
    })
  },
  methods: {
    getCompany (id, shouldResetName = true) {
      axios.post('api/companies/get-company', {id}).then(response => {
        const company = response.data.data;

        if (shouldResetName) {
          this.$set(this.instructions, 'recipient', company.name);
        }
        if (!this.instructions.account_number) {
          this.$set(this.instructions, 'account_number', company.account_number);
        }

      }).catch(errors => {
        console.log(errors);
      })
    },
    getDebtContractsList () {
      axios.post('api/contract-instructions/get-debt-amounts-contracts', {
        client_id: this.$route.params.client_id,
        date: this.instructions.transfer_date
      }).then(response => {
        this.schedules = response.data;
      }).catch(errors => {
        console.log(errors);
      })
    },
    addCondition () {
      this.condition = JSON.parse(JSON.stringify(ClientUtils._condition));
      this.condition.status = !!this.condition.status;
      this.condition_modal = true;
    },
    closeCondition () {
      this.condition_modal = false;
    },
    saveCondition () {
      this.instructions.conditions.push(this.condition);
      this.condition = JSON.parse(JSON.stringify(ClientUtils._condition));
      this.condition.status = !!this.condition.status;
      this.condition_modal = false;
    },
    removeCondition (index_to_remove) {
      this.instructions.conditions = this.instructions.conditions.filter((_, index) => index != index_to_remove);
    },
    saveInstructions () {
      let instructionsToSave = JSON.parse(JSON.stringify(this.instructions));
      for (let i = 0; i < instructionsToSave.conditions.length; i++) {
        instructionsToSave.conditions[i].status = +instructionsToSave.conditions[i].status;
      }

      this.actionInProgress = true;
      let endpointUrl = instructionsToSave.id ? '/api/contract-instructions/update/' + instructionsToSave.id : '/api/contract-instructions/store';

      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: instructionsToSave,
        successTitle: 'Uruchomienie dyspozycji zostało zapisane.',
        successText: '',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Zapisywanie uruchomienia dyspozycji nie powiodło się. Spróbuj ponownie.',
        successAction: (response) => {
          this.actionInProgress = false;
          this.closeInstructions(true);
        },
        failAction: (error) => {
          this.actionInProgress = false;
          console.log(error);

          if (error.data.errors) {
            LarErrors.record(error.data.errors);
          }
        }
      });
    },
    closeInstructions (shouldReload = false) {
      this.$bus.$emit('contract-instructions-form-close', shouldReload);
    }
  }
}
</script>

<style lang="scss" scoped>
.action-cell {
  width: 90px;
}
</style>